<template>
  <v-app id="app" @click.native.ctrl.alt="developersDialog = true">
    <template v-if="isAppReady">
      <v-navigation-drawer
        app
        right
        clipped
        dark
        class="secondary"
        v-if="user"
      >
        <m-navbar />
      </v-navigation-drawer>

      <v-app-bar app clipped-right class="secondary darken-1" v-if="user">
        <v-img
            style="border-radius: 30%"
            contain
            max-height="40"
            max-width="40"
            src="/img/icons/logo.svg"
        ></v-img>
        <span style="font-size: larger " class="white--text mr-3 font-weight-bold">ادمین</span>
        <span style="font-size: larger " class="primary--text mr-2 font-weight-bold">ابر مالی سبحـان</span>
        <v-spacer></v-spacer>
        <span class="white--text mr-3 ml-5">
        </span>
        <v-avatar v-if="!user.profile_picture" size="34" class=" rounded-lg" color="white">
          <v-img id="menu-activator" src="/img/icons/profile.svg" max-width="25" max-height="25"></v-img>
        </v-avatar>
        <v-avatar v-if="user.profile_picture" size="34" class=" rounded-lg" color="secondary">
          <v-img v-if="user.profile_picture" id="menu-activator" :src="img_source(user.profile_picture)"> </v-img>
        </v-avatar>

        <v-menu activator="#menu-activator" offset-y transition="slide-y-transition" open-on-hover class="rounded-lg">
          <v-list>
            <v-list-item>
              <v-list-item-avatar color="secondary">
                <v-img v-if="user.profile_picture" :src="img_source(user.profile_picture)"> </v-img>
                <v-img
                    max-width="30"
                    max-height="30"
                    class="mr-1"
                    v-if="!user.profile_picture"
                    src="/img/icons/profile_dark.svg"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-title>
                {{ user.name || user.username }}
                <span class="success--text mr-3" style="font-size: x-small">
                  <v-icon x-small color="success" class="mb-1">fa-check</v-icon>
                  آنلاین
                </span>

              </v-list-item-title>
            </v-list-item>
            <v-divider class="border-opacity-50" color="primary"></v-divider>
            <v-list-item @click="logout" active-class="back">
              <v-list-item-avatar size="30" color="secondary">
                <v-img class="mr-1" src="/img/icons/logout-dark.svg" max-width="27" max-height="27"></v-img>
              </v-list-item-avatar>
              <v-list-item-title> خروج</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-app-bar>

      <loader />

      <v-main class="app-background-color">
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-main>

      <v-snackbar
        :value="snackbar.show"
        @input="$store.commit('setSnackbar', {show:false})"
        :color="snackbar.color"
        :left="true"
        :outlined="false"
      >
        <!-- <v-btn color="white" outlined @click="$store.commit('setSnackbar', {show:false})">بستن</v-btn> -->
        <v-btn color="white" icon @click="$store.commit('setSnackbar', {show:false})">
          <v-icon>fa-times</v-icon>
        </v-btn>
        {{ snackbar.text }}
      </v-snackbar>
    </template>

    <v-dialog
      v-model="developersDialog"
      scrollable
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="ltr">
        <v-card-title class="text-center">Welcome Developer!</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field class="ltr" label="Server Url" v-model="serverUrl" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import mNavbar from "@/components/Navbar";
import Loader from "@/components/Loader";

import moment from "moment-jalaali";

import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    mNavbar,
    Loader,
  },
  data() {
    return {
      isAppReady: true,
      showDrawer: false,
      developersDialog: false,
    };
  },
  computed: {
    serverUrl: {
      get() {
        return localStorage.getItem("serverUrl");
      },
      set(value) {
        localStorage.setItem("serverUrl", value);
      },
    },
    ...mapState({
      snackbar: (state) => state.snackbar,
    }),
  },
  created() {
    if (!this.isDev) {
      this.request({
        url: "/configs.json",
        method: "get",
        token: false,
        success: (data) => {
          let serverUrl = data.serverUrl;
          localStorage.setItem("serverUrl", serverUrl);
          this.log(`server url is : ${serverUrl}`);
          this.getTime();
        },
      });
    } else {
      this.getTime();
    }
  },

  methods: {
    getTime() {
      this.request({
        url: this.endpoint(`home/time`),
        method: "get",
        token: false,
        success: (data) => {
          let now = moment(data.time);
          this.$store.commit("setTime", now);
        },
      });
    },
    routeClick(routeName) {
      if (this.$route.name == routeName) {
        this.EventBus.$emit("sameRouteClick");
      }
    },
    logout() {
      this.setToken("");
      this.$store.commit("setUser", null);
      if (this.$route.name != "Login") {
        this.$router.push({ name: "Login" });
      }
    },
  },
};
</script>

<style lang="scss">
@import "./styles/main";
</style>

